var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "colored",
    d: "M5.94439 16.9039V14.1437C5.94438 13.4443 6.50981 12.876 7.21018 12.8716H9.78181C10.4853 12.8716 11.0556 13.4412 11.0556 14.1437V16.8959C11.0556 17.5026 11.5457 17.9956 12.1532 18H13.9076C14.727 18.0021 15.5136 17.6785 16.0938 17.1006C16.6739 16.5228 17 15.7381 17 14.9198V7.07926C17 6.41825 16.7066 5.79124 16.1989 5.36715L10.2385 0.606842C9.19656 -0.22579 7.70849 -0.198893 6.69745 0.670846L0.865221 5.36715C0.333505 5.77874 0.0157047 6.40761 0 7.07926V14.9118C0 16.6173 1.3845 18 3.09237 18H4.80679C5.09926 18.0021 5.38049 17.8876 5.58805 17.6818C5.79562 17.476 5.91235 17.196 5.91235 16.9039H5.94439Z",
    fill: "#1BD15D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d87b9113.svg";
export { ForwardRef as ReactComponent };